import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toast } from "primereact/toast";
import { getSpecificItemDetails, getTwoFilteredDetails } from "../../service/ProductService";
import { GET_DASHBOARD_DATA } from "../../config/ApiConstant";
import { Messages } from "primereact/messages";
import { Calendar } from "primereact/calendar";
import { Link } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { Dialog } from "primereact/dialog";
import UpdatePaymentMethod from "../../components/BankDetails/BankDetails";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { ClientListUserDashboardColumn, UserDetailAdminDashboardColumn } from "../../appconfig/DatatableSetting";
import {
  defaultPageRowOptions,
  defaultRowOptionsInDashboard,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { Column } from "primereact/column";
import moment from "moment";
import { dateMonthYearTemplate, dollarTemplate, nameTemplate } from "../../appconfig/TemplateFieldSetting";

const UserDashboard = () => {
  document.title = "User Dashboard | Nexawage Payroll";
  const toast = useRef<any>(null);

  // message ref
  const msgs = useRef<any>(null);

  // dashboard data obj
  const [dashboardData, setDashboardData] = useState<any>();

  // page load obj
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  // year obj
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<Date | null>(new Date());

  // stripe card detail form model
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  //  Modal state for first-time visit
  const [showBankModal, setShowBankModal] = useState(false);

  // current month year
  const [currentMonthYear, setCurrentMonthYear] = useState<Date | any>(new Date());

  // client payment list
  const [clientPaymentList, setClientPaymentList] = useState<any>([]);

  // card detail added status
  const [cardAddedOrNot, setCardAddedOrNot] = useState<boolean>();

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  //   useEffect to get dashboard data
  useEffect(() => {
    getDashboard();
  }, [currentMonthYear, selectedYear]);

  // get dashboard data
  const getDashboard = async (year = currentYear) => {
    try {
      const response = await getTwoFilteredDetails(GET_DASHBOARD_DATA, "year", year, "month_year", moment(currentMonthYear).format("YYYY-MM"));
      const data = response.data;

      if (data) {
        // set client list
        setClientPaymentList(data?.userObj?.clientsList);
        setDashboardData(data);
        setPageLoad(true);

        // set card detail status
        // const cardAddedStatus = data?.payment_array?.length > 0 ? true : false;
        // setCardAddedOrNot(cardAddedStatus);

        setCardAddedOrNot(data?.payment_details_added);

        // set local storage with card detail added or not (flag)
        const payment_details_added = data?.payment_details_added;
        localStorage.setItem("payment_details_added", payment_details_added);
      } else {
        setDashboardData({});
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // use Effect to display message to add bank details
  useEffect(() => {
    if (msgs.current) {
      msgs.current.show({
        sticky: true,
        severity: "info",
        summary: "Click here to add card details",
        detail: "",
        closable: false,
      });
    }
  }, []);

  // Check if user added bank detail or not
  useEffect(() => {
    if (!pageLoad) return;

    const model_status = localStorage.getItem("payment_model_status");

    // check if user has added bank details or not
    const bank_detail_added = dashboardData?.payment_details_added;

    // Show modal only if bank details NOT added
    if (model_status !== "true" && bank_detail_added !== true) {
      if (userRole === "User") {
        setShowBankModal(true);
      }
    }
  }, [dashboardData, pageLoad]);

  return (
    <>
      <AppBreadcrumb pageTitle="Dashboard" pageName="Dashboard" currentMenu="User" />
      <Toast ref={toast} />
      <div className="layout-dashboard">
        <div className={`flex align-items-center justify-content-between`}>
          {/* <div className="app-messages mb-0">
            <Messages
              
              className="mb-0"onClick={() => setShowPaymentModal(true)}
              ref={msgs}
            />
          </div> */}

          {/* <div
            className="app-messages-info"
            onClick={() => setShowPaymentModal(true)}
          >
            <div
              className={`${
                dashboardData?.payment_details_added === true
                  ? "message-info-card-added"
                  : "message-info-card-not-added"
              }`}
            >
              <span className="message-icon pi pi-info-circle" />
              <div className="message-content">
                <span className="message-summary">
                  Click hear to add card details and enable access to all
                  features.
                </span>
              </div>
            </div>
          </div> */}

          {/* {pageLoad && (
            <div
              className="app-messages-info"
              onClick={() => {
                if (!dashboardData?.payment_details_added) {
                  setShowPaymentModal(true);
                }
              }}
            >
              <div
                className={
                  dashboardData?.payment_details_added
                    ? "message-info-card-added"
                    : "message-info-card-not-added"
                }
              >
                <span
                  className={`message-icon pi ${
                    dashboardData?.payment_details_added
                      ? "pi-check-circle"
                      : "pi-info-circle"
                  }`}
                />

                <div className="message-content">
                  <span className="message-summary">
                    {dashboardData?.payment_details_added
                      ? "Your card details are successfully added. All features are now enabled."
                      : "Add your card details to enable all features and start receiving payments."}
                  </span>
                </div>
              </div>
            </div>
          )} */}

          {pageLoad && (
            <div
              className="app-messages-info"
              onClick={() => {
                // Allow click only when user wants to add/update card
                setShowPaymentModal(true);
              }}
            >
              <div className={cardAddedOrNot === true ? "message-info-card-added" : "message-info-card-not-added"}>
                <span className={`message-icon pi ${cardAddedOrNot === true ? "pi-check-circle" : "pi-exclamation-circle"}`} />

                <div className="message-content">
                  <span className="message-summary font-semibold">
                    {cardAddedOrNot === true ? "Card details are added" : "Card details required"}
                  </span>

                  <p className="message-detail">
                    {cardAddedOrNot === true
                      ? "Your card is added and all features are enabled. You may add another card at any time."
                      : "To enable full access to payroll and billing features, please add your card details."}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="grid mt-2">
          {/* total clients */}
          <div className="col-12 md:col-6 lg:col-4">
            <Link to="/clients">
              <div className="card dashbaord-main-box">
                <div className="small-box bg-info">
                  <div className="inner" style={{ borderLeft: "3px solid #0d6efd" }}>
                    <div className="flex flex-column justify-content-between">
                      <h2 className="mb-1 title-text">Total Clients</h2>
                      <div className="flex align-items-center justify-content-between">
                        <h3 className="mt-0 mb-0 num-text" style={{ color: "#0d6efd" }}>
                          {pageLoad ? (
                            !window.cn(dashboardData.users_client_count) ? (
                              dashboardData.users_client_count
                            ) : (
                              ""
                            )
                          ) : (
                            <Skeleton width="5rem" height="2.5rem" className="rounded" />
                          )}
                        </h3>
                        <div
                          className="dashboard-icon"
                          style={{
                            padding: "0.35rem",
                            backgroundColor: "#e7f0ff",
                            borderRadius: "9999px",
                            color: "#0d6efd",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-building2"
                          >
                            <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                            <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                            <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                            <path d="M10 6h4" />
                            <path d="M10 10h4" />
                            <path d="M10 14h4" />
                            <path d="M10 18h4" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
        {/* user payment detail table */}
        <div className=" mt-0 bg-white p-3" style={{ borderRadius: "10px" }}>
          <div className="flex justify-content-between">
            <h4 className="p-0 pb-3 m-0">Client Payment Overview</h4>
            <div className="flex" style={{ flexDirection: "column" }}>
              <label className="text-center mb-1" style={{ fontWeight: 600 }}>
                Billing Month:{" "}
              </label>

              <Calendar
                value={currentMonthYear}
                onChange={(e) => setCurrentMonthYear(e.value)}
                view="month"
                dateFormat="mm/yy"
                placeholder="Select Month/Year"
                showIcon
                className=""
              />
            </div>
          </div>

          <div className=" grid col-12 md:col-12">
            {/* current month amount */}
            <div className="col-12 md:col-3 lg:col-3">
              <div className="card dashbaord-main-box">
                <div className="small-box bg-info">
                  <div className="inner" style={{ borderLeft: "3px solid #35b653" }}>
                    <div className="flex flex-column justify-content-between ">
                      <h5 className="mb-1" style={{ fontSize: "15px" }}>
                        Selected Month Total Amount
                      </h5>
                      <div className="flex align-items-center justify-content-between">
                        <h5 className="mt-0 mb-0" style={{ color: "#35b653" }}>
                          {pageLoad ? (
                            !window.cn(dashboardData.userObj) ? (
                              `$${dashboardData?.userObj?.currentMonthTotal ?? "0.00"}`
                            ) : (
                              ""
                            )
                          ) : (
                            <Skeleton width="5rem" height="2.5rem" className="rounded" />
                          )}
                        </h5>
                        <div
                          className="dashboard-icon"
                          style={{
                            padding: "0.35rem",
                            backgroundColor: "#e8fff2",
                            borderRadius: "9999px",
                            color: "#35b653",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-dollar-sign-circle"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 6v12" />
                            <path d="M16 8H10a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* upcomming month amount */}
            <div className="col-12 md:col-3 lg:col-3">
              <div className="card dashbaord-main-box">
                <div className="small-box bg-info">
                  <div className="inner" style={{ borderLeft: "3px solid #e9cf24" }}>
                    <div className="flex flex-column justify-content-between ">
                      <h5 className="mb-1" style={{ fontSize: "15px" }}>
                        Upcoming Month Total Amount
                      </h5>
                      <div className="flex align-items-center justify-content-between">
                        <h5 className="mt-0 mb-0" style={{ color: "#e9cf24" }}>
                          {pageLoad ? (
                            !window.cn(dashboardData.userObj) ? (
                              `$${dashboardData?.userObj?.upcomingMonthTotal ?? "0.00"}`
                            ) : (
                              ""
                            )
                          ) : (
                            <Skeleton width="5rem" height="2.5rem" className="rounded" />
                          )}
                        </h5>
                        <div
                          className="dashboard-icon"
                          style={{
                            padding: "0.35rem",
                            backgroundColor: "#fff8c9",
                            color: "#e9cf24",
                            borderRadius: "9999px",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-dollar-sign-circle"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 6v12" />
                            <path d="M16 8H10a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-12">
            <Card className=" bg-white payment-detail-table" style={{ boxShadow: "0px 0px 6px 2px #d8dde6" }}>
              <div className="card-header mb-3 flex justify-content-between">
                <h5 className="font-bold text-gray-700 mb-0">Client Charge List</h5>
              </div>
              {pageLoad ? (
                <DataTable
                  className="p-datatable-customers "
                  value={clientPaymentList}
                  responsiveLayout={"scroll"}
                  // showGridlines
                  // stripedRows
                  dataKey="id"
                  paginator={clientPaymentList?.length > 0}
                  rows={defaultRowOptionsInDashboard}
                  rowsPerPageOptions={defaultPageRowOptions}
                  paginatorTemplate={paginatorLinks}
                  currentPageReportTemplate={showingEntries + " Clients"}
                  emptyMessage="No Client Found"
                  rowHover
                >
                  {ClientListUserDashboardColumn.map((col: any, i: any) => {
                    if (col.field === "name") {
                      return <Column key={col.field} field={col.field} header={col.header} />;
                    } else if (col.field === "unique_id") {
                      return (
                        <Column
                          key={col.field}
                          field={col.field}
                          header={col.header}
                          // body={userDetailTemplate}
                        />
                      );
                    } else if (col.field === "client_charge") {
                      return <Column key={col.field} field={col.field} header={col.header} body={dollarTemplate} />;
                    } else if (col.field === "client_subs_month_year") {
                      return <Column key={col.field} field={col.field} header={col.header} body={dateMonthYearTemplate} />;
                    } else {
                      return <Column key={col.field} field={col.field} header={col.header} />;
                    }
                  })}
                </DataTable>
              ) : (
                <DataTable value={Skeletonitems}>
                  {ClientListUserDashboardColumn.map((col: any) => (
                    <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                  ))}
                </DataTable>
              )}
            </Card>
          </div>
        </div>
      </div>

      {/* add bank details model */}
      <Dialog
        header="Add Card Details"
        visible={showBankModal}
        onHide={() => {
          setShowBankModal(false);
          localStorage.setItem("payment_model_status", "true");
        }}
        modal
        draggable={false}
        dismissableMask={false}
        className="bank-details-modal mx-0 lg:mx-0"
        style={{ width: "30rem" }}
        footer={<div></div>}
      >
        <p className="m-0 text-center">It looks like you haven't added your card details yet.</p>

        <div className="flex justify-content-center mt-4">
          <button
            className="bank-modal-btn"
            onClick={() => {
              setShowBankModal(false);
              setShowPaymentModal(true);
              localStorage.setItem("payment_model_status", "true");
            }}
          >
            Add Card Details
          </button>
        </div>
      </Dialog>

      {/* dialog for stripe card detail form */}
      <Dialog
        header="Add Card Details"
        visible={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        modal
        draggable={false}
        dismissableMask={false}
        style={{ width: "35rem" }}
        className="mx-3 lg:mx-0"
        footer={<div></div>}
      >
        <UpdatePaymentMethod customerId={userData?.customer_id} onSuccess={() => setShowPaymentModal(false)} getApiCall={() => getDashboard()} />
      </Dialog>
    </>
  );
};

export default UserDashboard;
